import React, { useMemo } from 'react';
import DOMPurify from 'dompurify';
import he from "he";
import { Link } from "react-router-dom";
import { useAccountSettings } from '../../services/Context/AccSettingContext';
import { useLanguageRes } from "../../services/Context/LanguageContext";

const Footer = () => {

    const { accountSettings, account, getAccountsettingValue } = useAccountSettings();
    const { getLanguageContent } = useLanguageRes();

    // Derived during render (not in effects) so the footer never paints a frame without its content.
    const brandingText = useMemo(() => (Array.isArray(accountSettings) ? getAccountsettingValue(accountSettings, "CBT") || null : null), [accountSettings]);

    const footer = useMemo(() => {
        const data = Array.isArray(account?.portalSettings) ? account.portalSettings.find((list) => list?.code == "FTC") : null;
        return data ? he.decode(DOMPurify.sanitize(data?.value)) : null;
    }, [account]);


    const sanitizeAndAddRel = (htmlContent) => {
        if (!htmlContent) return '';

        return htmlContent.replace(
            /<a\s+(?![^>]*rel=["']noopener noreferrer["'])[^>]*target=["']_blank["']/gi,
            (match) => {
                return match.replace(/target=["']_blank["']/, `target="_blank" rel="noopener noreferrer"`);
            }
        );
    };

    return (
        <>
            <footer className="footer-container">
                <div>
                    {footer && (
                        <div dangerouslySetInnerHTML={{ __html: sanitizeAndAddRel(footer) }}>
                        </div>
                    )}
                                       
                    {brandingText && (
                        <>
                            <div className="d-none d-lg-flex align-items-center w-100 mt-2 position-relative" style={{ minHeight: 20 }}>
                                {/* Centered Branding Text */}
                                <div
                                    style={{
                                        position: "absolute",
                                        left: "50%",
                                        top: "50%",
                                        transform: "translate(-50%, -50%)",
                                        whiteSpace: "nowrap",
                                        textAlign: "center",
                                        width: "max-content",
                                        maxWidth: "80%",
                                    }}
                                >
                                    <div dangerouslySetInnerHTML={{ __html: sanitizeAndAddRel(brandingText) }}></div>
                                </div>
                                {/* Right-aligned Links */}
                                <div className="ms-auto">
                                    <Link to="/terms" className="text-decoration-underline me-3">
                                        <small>{getLanguageContent("trmuse")}</small>
                                    </Link>
                                    <Link to="/privacy" className="text-decoration-underline">
                                        <small>{getLanguageContent("prvpol")}</small>
                                    </Link>
                                </div>
                            </div>

                            <div className="d-lg-none mt-2">
                                {/* First row: Branding text (dangerous HTML) */}
                                <div className="d-flex justify-content-center mb-1">
                                    <div
                                        className="text-center"
                                        dangerouslySetInnerHTML={{ __html: sanitizeAndAddRel(brandingText) }}
                                    ></div>
                                </div>

                                {/* Second row: Terms and Privacy links side by side, centered */}
                                <div className="d-flex justify-content-center">
                                    <Link to="/terms" className="text-decoration-underline mx-2">
                                        <small>{getLanguageContent("trmuse")}</small>
                                    </Link>
                                    <Link to="/privacy" className="text-decoration-underline mx-2">
                                        <small>{getLanguageContent("prvpol")}</small>
                                    </Link>
                                </div>
                            </div>
                        </>
                    )}

                    
                </div>
            </footer>
        </>
    );
}

export default Footer;